import { msg } from '@lingui/core/macro'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { HomePage } from '~/components/dashboard/dashboard-page'
import { type HomeSearchTab, homeTabFromSearch } from '~/components/dashboard/home-tab'
import { titleFor } from '~/lib/route-title'

type HomeSearch = { tab?: HomeSearchTab }

export const Route = createFileRoute('/_authenticated/$workspaceSlug/home')({
  beforeLoad: ({ params, search }) => {
    if (search.tab === 'updates') {
      throw redirect({
        params: { workspaceSlug: params.workspaceSlug },
        to: '/$workspaceSlug/updates',
      })
    }
  },
  component: RouteComponent,
  head: () => ({ meta: [{ title: titleFor(msg`Home`) }] }),
  validateSearch: (search: Record<string, unknown>): HomeSearch => ({
    tab: homeTabFromSearch(search.tab),
  }),
})

function RouteComponent() {
  const { tab } = Route.useSearch()
  return <HomePage tab={tab === 'mine' ? 'mine' : 'workspace'} />
}
